module.exports = __webpack_public_path__ + "img/card-4.c86069b4.jpeg";